export const enum ButtonSize {
    sm,
    md,
    lg,
    xl,
}
